import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { getScreenNameFromRoute } from '../../constants/screen-routes';
import { isSidebarApp } from '../../reducers/utils';

export function useScreenName(): string {
  let location;
  try {
    location = useLocation();
  } catch (error) {
    console.warn('useScreenName hook threw an error', error);
    location = { hash: '', pathname: '/calendar' };
  }

  const { hash, pathname } = location;

  const screenName = useMemo(() => {
    const route = hash && !isSidebarApp(hash) ? hash : pathname;
    const routeFragment = route.replace(/^\/#?/, '');
    const currentRoute = routeFragment || 'calendar';

    return getScreenNameFromRoute(currentRoute);
  }, [hash, pathname]);

  return screenName;
}
